import { CommitOutput } from 'APP/libs/mls-rs-wasm';
import { IE2eeAddParticipantWelcome } from 'APP/model/e2ee/e2eeModel.types';

export interface IAddMembersOutput {
  commit: ArrayBuffer;
  epoch: bigint;
  welcomeMessages: IE2eeAddParticipantWelcome[];
  welcomeCommit: CommitOutput;
}

export interface IRemoveMembersOutput {
  commit: ArrayBuffer;
  epoch: bigint;
  commitOutput: CommitOutput;
}

export interface IStorageKeyPair {
  cipherSuite: string;
  publicKey: string;
  secretKey: string;
}

export type GroupStates = { [key: string]: string };
export type EpochStates = { [key: string]: { [key: string]: string } };
export type GroupMaxEpoch = { [key: string]: string };

export enum MLSErrors {
  groupNotFound = 'Exception.MlsError: A mls-rs error occurred: group not found',
}
